const archiveRouterLinks = {
  archivePage: '/archive',
  archiveNotesPage: '/archive/notes',
  archiveCalendarPage: '/archive/calendar',
  archiveDocsPage: '/archive/docs'
};

export default archiveRouterLinks;
